import { LoadingDots, Wizard } from '@flos/react-ui';
import { Suspense } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useHippoText } from '../../../hooks/useHippoText';
import { checkoutProgressSelector } from '../../../recoil/selectors/checkoutProgressSelector';
import { checkoutProgressAtom } from '../../../recoil/atoms/checkoutProgressAtom';

const CheckoutAccordion = ({
    wizardNextStep
}: {
    wizardNextStep: () => void;
}): React.JSX.Element => {
    const setCheckoutStep = useSetRecoilState(checkoutProgressAtom);
    const checkoutProgress = useRecoilValue(checkoutProgressSelector);
    const getHippoText = useHippoText();
    const goNext = (): void => {
        if (checkoutProgress.currentStep < checkoutProgress.totalSteps) {
            setCheckoutStep((prevStep) => prevStep + 1);
        } else {
            wizardNextStep();
        }
    };

    return (
        <Suspense fallback={<LoadingDots />}>
            <Wizard.Container variant="vertical" currentStep={checkoutProgress.currentStep}>
                {checkoutProgress.steps.map((step, stepIndex) => {
                    const { titleKey, Component, shouldHideTitle = false } = step;
                    return (
                        <Wizard.Pane
                            key={titleKey}
                            title={!shouldHideTitle ? getHippoText(titleKey) : undefined}
                            active={checkoutProgress.currentStep > stepIndex + 1}
                            onChange={(e) => {
                                if (typeof e === 'number') {
                                    setCheckoutStep(e);
                                }
                            }}
                            className="u-spacing-inset-5 u-spacing-inset-7@xs"
                        >
                            <Component goNext={goNext} />
                        </Wizard.Pane>
                    );
                })}
            </Wizard.Container>
        </Suspense>
    );
};

export default CheckoutAccordion;
